import moment from "moment";


export function isBirthdayToday(dob) {
  if (!dob) return false;
  let parsed = moment(dob, moment.ISO_8601, true);
  if (!parsed.isValid()) {
    parsed = moment(dob, "DD-MM-YYYY", true);
  }
  if (!parsed.isValid()) return false;

  const today = moment();
  return parsed.month() === today.month() && parsed.date() === today.date();
}
